import React from "react";
import { Typography, useTheme, useMediaQuery } from "@mui/material";
import styled from "styled-components";

const SubText = styled(Typography)`
  color: ${props => props.theme.palette.text.secondary};
  line-height: 1.7;
  text-align: center;
  padding-top: 80px;
  padding-bottom: 256px;
`;

export const FeatureSubtext: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <SubText 
      variant={"h2"}
      sx={{
        fontSize: isMobile ? '1.2rem' : '1.5rem',
        fontWeight: 500,
        color: theme.palette.text.secondary
      }}
    >
      Celebrate your story with beautifully designed maps.
      <br />
      A timeless gift for every special moment.
    </SubText>
  );
};
